import axios from 'axios';

// Define the base API URL
// Removing the duplication of the /api prefix
const API_URL = process.env.REACT_APP_API_URL || 'https://api.planmyplate.io';

// Function to sign in as administrator
export async function signIn(username: string, password: string) {
  try {
    const response = await axios.post(`${API_URL}/api/admin/login`, {
      username,
      password
    });
    
    // Store token in localStorage
    if (response.data.token) {
      localStorage.setItem('admin_token', response.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
    }
    
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Error during login');
    }
    throw new Error('Error connecting to server');
  }
}

// Function to register a new administrator with image upload support
export async function signUp(
  email: string, 
  password: string, 
  first_name: string,
  last_name: string,
  avatar?: string
) {
  try {
    // Prepare data for submission
    const payload: any = {
      email,
      password,
      first_name,
      last_name,
      role: 'admin' // Setting role=admin by default
    };

    // If there's an image in base64 format, include it in the payload
    if (avatar && avatar.startsWith('data:image')) {
      payload.avatar = avatar;
    }

    const response = await axios.post(`${API_URL}/api/admin/register`, payload);
    
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Error registering user');
    }
    throw new Error('Error connecting to server');
  }
}

// Function to check if user is authenticated
export function isAuthenticated() {
  return localStorage.getItem('admin_token') !== null;
}

// Function to log out
export function logout() {
  localStorage.removeItem('admin_token');
  delete axios.defaults.headers.common['Authorization'];
}

// Function to get the current token
export function getToken() {
  return localStorage.getItem('admin_token');
}

// Set up the auth token in the request headers when the application starts
export function setupAuthToken() {
  const token = getToken();
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
}